import React from "react";
import classes from "./ToggleButton.module.css";
import { CheveronLeft } from "../../../constant";
const TogglerButton = ({onClick ,...rest}) => {
  return (
    <button onClick={onClick} className={classes.toggleButton} {...rest}>
      <CheveronLeft />
    </button>
  );
};

export default TogglerButton;
